module.exports = __webpack_public_path__ + "static/media/AvenirNext-Regular.7ff0bf11.ttf";